import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { global } from '@ckeditor/ckeditor5-utils';
/**
 * Basic HTML writer. It uses the native `innerHTML` property for basic conversion
 * from a document fragment to an HTML string.
 */
var BasicHtmlWriter = /*#__PURE__*/function () {
  function BasicHtmlWriter() {
    _classCallCheck(this, BasicHtmlWriter);
  }
  _createClass(BasicHtmlWriter, [{
    key: "getHtml",
    value:
    /**
     * Returns an HTML string created from the document fragment.
     */
    function getHtml(fragment) {
      var doc = global.document.implementation.createHTMLDocument('');
      var container = doc.createElement('div');
      container.appendChild(fragment);
      return container.innerHTML;
    }
  }]);
  return BasicHtmlWriter;
}();
export { BasicHtmlWriter as default };